export default __webpack_public_path__ + "static/media/Bryan.b9dad911.webp";